var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _c(
            "Aggregate",
            _vm._b(
              {
                attrs: {
                  title: "Generators",
                  "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                    "input",
                    "generators",
                  ]),
                  ItemConstructor: _vm.generatorFactory,
                  headers: _vm.headers,
                  "copy-btn": "",
                  dense: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "add",
                    fn: function (ref) {
                      var addItem = ref.addItem
                      var addItemMultiple = ref.addItemMultiple
                      var replaceItemMultiple = ref.replaceItemMultiple
                      return [
                        _c(
                          "v-menu",
                          {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g({ attrs: { icon: "" } }, on),
                                        [_c("v-icon", [_vm._v("mdi-plus")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item",
                                  { on: { click: addItem } },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      [_c("v-icon", [_vm._v("mdi-plus")])],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("Create generator"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "DialogForm",
                                  {
                                    attrs: {
                                      title: "Import generators from file",
                                      maxWidth: "600",
                                      accept: ".xlsx",
                                      submit: _vm.submitMultipleItems(
                                        addItemMultiple,
                                        replaceItemMultiple,
                                        _vm.generatorsForm
                                      ),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var dialogOn = ref.on
                                            return [
                                              _c(
                                                "v-list-item",
                                                _vm._g({}, dialogOn),
                                                [
                                                  _c(
                                                    "v-list-item-icon",
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-file-upload-outline"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          "Upload from file"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("ImportSpreadsheet", {
                                      attrs: {
                                        "start-year": _vm.startYear,
                                        "num-years": _vm.num_years,
                                        replace: _vm.replaceImportedItems,
                                      },
                                      on: {
                                        "update:replace": function ($event) {
                                          _vm.replaceImportedItems = $event
                                        },
                                      },
                                      model: {
                                        value: _vm.generatorsForm,
                                        callback: function ($$v) {
                                          _vm.generatorsForm = $$v
                                        },
                                        expression: "generatorsForm",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "append-top",
                    fn: function () {
                      return [
                        _c(
                          "v-dialog",
                          {
                            attrs: { "max-width": "600" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var dialogOn = ref.on
                                  return [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var tooltipOn = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      { attrs: { icon: "" } },
                                                      Object.assign(
                                                        {},
                                                        tooltipOn,
                                                        dialogOn
                                                      )
                                                    ),
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-pencil"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v("Edit multiple items"),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.multipleEditDialog,
                              callback: function ($$v) {
                                _vm.multipleEditDialog = $$v
                              },
                              expression: "multipleEditDialog",
                            },
                          },
                          [
                            _c("MultipleEdit", {
                              attrs: {
                                input: _vm.input,
                                settings: _vm.settings,
                              },
                              on: {
                                "update:input": function ($event) {
                                  _vm.input = $event
                                },
                                close: function ($event) {
                                  _vm.multipleEditDialog = false
                                },
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "item.active",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("v-switch", {
                          staticClass: "mt-0",
                          attrs: { dense: "", "hide-details": "" },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("change")
                            },
                          },
                          model: {
                            value: item.active,
                            callback: function ($$v) {
                              _vm.$set(item, "active", $$v)
                            },
                            expression: "item.active",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.type",
                    fn: function (ref) {
                      var item = ref.item
                      var errors = ref.errors
                      var allowEdit = ref.allowEdit
                      return [
                        _c("v-select", {
                          attrs: {
                            items: _vm.types,
                            "error-messages": _vm.$utils.getIfExists(errors, [
                              "type",
                              "messages",
                            ]),
                            disabled: !allowEdit || item.noDelete,
                            label: "Generator Type",
                            "single-line": "",
                            dense: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("change")
                            },
                          },
                          model: {
                            value: item.type,
                            callback: function ($$v) {
                              _vm.$set(item, "type", $$v)
                            },
                            expression: "item.type",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.source",
                    fn: function (ref) {
                      var item = ref.item
                      var errors = ref.errors
                      var allowEdit = ref.allowEdit
                      return [
                        item.type === "HYDRO"
                          ? _c("span", [_vm._v("Hydro")])
                          : _c("v-select", {
                              attrs: {
                                items: _vm.sources[item.type],
                                "error-messages": _vm.$utils.getIfExists(
                                  errors,
                                  ["source", "messages"]
                                ),
                                disabled: !allowEdit || item.noDelete,
                                label: "Source",
                                "single-line": "",
                                dense: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.sourceChange($event, item.id)
                                },
                              },
                              model: {
                                value: item.source,
                                callback: function ($$v) {
                                  _vm.$set(item, "source", $$v)
                                },
                                expression: "item.source",
                              },
                            }),
                      ]
                    },
                  },
                  {
                    key: "item.bus_id",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("v-select", {
                          attrs: {
                            clearable: "",
                            items: _vm.nodeIndex,
                            label: _vm.thermalSchema.bus_id.title,
                            "single-line": "",
                            dense: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$emit("change")
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.item.name) + " "),
                                    _c(
                                      "span",
                                      { staticClass: "text-caption ml-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            "(ID: " + data.item.value + ")"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _vm._v(" " + _vm._s(data.item.name) + " "),
                                    _c(
                                      "span",
                                      { staticClass: "text-caption ml-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            "(ID: " + data.item.value + ")"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.bus_id,
                            callback: function ($$v) {
                              _vm.$set(item, "bus_id", $$v)
                            },
                            expression: "item.bus_id",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.capacity",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("p", { staticClass: "mb-2" }, [
                          _vm._v(_vm._s(item.capacity[0]) + " MW"),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var item = ref.item
                      var errors = ref.errors
                      return [
                        _c(
                          "v-card",
                          { staticClass: "pa-2 ma-2", attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("General")]
                                    ),
                                    _c("InputGeo", {
                                      attrs: {
                                        label: "Coordinates",
                                        "map-height": "150",
                                        nullable: "",
                                        "switch-text": "Set coordinates",
                                        icon: _vm.generatorIconName(item),
                                        "initial-coordinates":
                                          _vm.nodeCoordinates(item.bus_id),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.coordinates,
                                        callback: function ($$v) {
                                          _vm.$set(item, "coordinates", $$v)
                                        },
                                        expression: "item.coordinates",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.hydroSchema.technical_life.title,
                                        hint:
                                          "Technical life influences generation unit retirement, directly impacting the minimum installed capacity requirement. Retirement: " +
                                          _vm.retirementYear(item) +
                                          ".",
                                        "persistent-hint": "",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "technical_life",
                                            "messages",
                                          ]),
                                        suffix: "years",
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.technical_life,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "technical_life",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.technical_life",
                                      },
                                    }),
                                    _c("InputToggleParam", {
                                      attrs: {
                                        label:
                                          _vm.hydroSchema.operating_status
                                            .properties.active.title,
                                        hint: _vm.hydroSchema.operating_status
                                          .properties.active.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "operating_status",
                                          ]),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var param = ref.param
                                              return [
                                                _c("InputProfile", {
                                                  attrs: {
                                                    hint: "Sets generator run mode (e.g., must-run, seasonal)",
                                                    "profile-type":
                                                      "DAILY_OPERATING_STATUS",
                                                    "hide-divider": "",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.$emit("change")
                                                    },
                                                  },
                                                  model: {
                                                    value: param.id,
                                                    callback: function ($$v) {
                                                      _vm.$set(param, "id", $$v)
                                                    },
                                                    expression: "param.id",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.operating_status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "operating_status",
                                            $$v
                                          )
                                        },
                                        expression: "item.operating_status",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.hydroSchema.start_year.title,
                                        suffix: _vm.hydroSchema.start_year.unit,
                                        hint: _vm.hydroSchema.start_year
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "start_year",
                                            "messages",
                                          ]),
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.start_year,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "start_year",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.start_year",
                                      },
                                    }),
                                    _c("v-switch", {
                                      attrs: {
                                        label:
                                          _vm.hydroSchema.include_elcc.title,
                                        hint: _vm.hydroSchema.include_elcc
                                          .tooltip,
                                        "persistent-hint": "",
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.include_elcc,
                                        callback: function ($$v) {
                                          _vm.$set(item, "include_elcc", $$v)
                                        },
                                        expression: "item.include_elcc",
                                      },
                                    }),
                                    item.type == "THERMAL"
                                      ? [
                                          _c("InputToggleParam", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.base_profile
                                                  .properties.active.title,
                                              hint: _vm.thermalSchema
                                                .base_profile.properties.active
                                                .tooltip,
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "base_profile",
                                                ]),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "below",
                                                  fn: function (ref) {
                                                    var param = ref.param
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "v-col",
                                                        { staticClass: "grow" },
                                                        [
                                                          _c(
                                                            "InputYearlyProfile",
                                                            {
                                                              attrs: {
                                                                hint: _vm
                                                                  .thermalSchema
                                                                  .base_profile
                                                                  .then
                                                                  .properties
                                                                  .param
                                                                  .properties
                                                                  .profiles
                                                                  .tooltip,
                                                                suffix:
                                                                  _vm
                                                                    .thermalSchema
                                                                    .base_profile
                                                                    .then
                                                                    .properties
                                                                    .param
                                                                    .properties
                                                                    .profiles
                                                                    .unit,
                                                                "error-messages":
                                                                  _vm.$utils.getIfExists(
                                                                    errors,
                                                                    ["profiles"]
                                                                  ),
                                                                num_years:
                                                                  _vm.num_years,
                                                                fill: "",
                                                                "profile-type":
                                                                  item.type,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$emit(
                                                                      "change"
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  param.profiles,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      param,
                                                                      "profiles",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "param.profiles",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: item.base_profile,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "base_profile",
                                                  $$v
                                                )
                                              },
                                              expression: "item.base_profile",
                                            },
                                          }),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "4",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-switch",
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          label:
                                                            _vm.thermalSchema
                                                              .minimum_operating_load
                                                              .title,
                                                          hint: _vm
                                                            .thermalSchema
                                                            .minimum_operating_load
                                                            .tooltip,
                                                          "persistent-hint": "",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item
                                                              .minimum_operating_load
                                                              .active,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item.minimum_operating_load,
                                                              "active",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.minimum_operating_load.active",
                                                        },
                                                      },
                                                      "v-switch",
                                                      _vm.$attrs,
                                                      false
                                                    )
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-expand-transition",
                                                [
                                                  item.minimum_operating_load
                                                    .active
                                                    ? _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "8",
                                                          },
                                                        },
                                                        [
                                                          _c("InputYearly", {
                                                            attrs: {
                                                              hint: _vm
                                                                .thermalSchema
                                                                .minimum_operating_load
                                                                .description,
                                                              suffix:
                                                                _vm
                                                                  .thermalSchema
                                                                  .minimum_operating_load
                                                                  .unit,
                                                              "error-messages":
                                                                _vm.$utils.getIfExists(
                                                                  errors,
                                                                  ["value"]
                                                                ),
                                                              num_years:
                                                                _vm.num_years,
                                                              fill: "",
                                                              "hide-divider":
                                                                "",
                                                              "fill-value": 1,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$emit(
                                                                  "change"
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                item
                                                                  .minimum_operating_load
                                                                  .value,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item.minimum_operating_load,
                                                                    "value",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.minimum_operating_load.value",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          item.source !== "GEOTHERMAL"
                                            ? _c("InputTextField", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema.heat_rate
                                                      .title,
                                                  hint: "Higher heat rate increases fuel consumption per MWh, raising unit operating costs",
                                                  "error-messages":
                                                    _vm.$utils.getIfExists(
                                                      errors,
                                                      ["heat_rate", "messages"]
                                                    ),
                                                  suffix:
                                                    _vm.thermalSchema.heat_rate
                                                      .unit,
                                                  type: "number",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.heat_rate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "heat_rate",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "item.heat_rate",
                                                },
                                              })
                                            : _vm._e(),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.ramp_rate
                                                  .title,
                                              hint: "This affects how quickly the generator unit can produce energy over consecutive operating hours",
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "ramp_rate",
                                                  "messages",
                                                ]),
                                              suffix: "MW/h",
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.ramp_rate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "ramp_rate",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.ramp_rate",
                                            },
                                          }),
                                          item.source !== "GEOTHERMAL"
                                            ? _c("InputTextField", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema.co2_rate
                                                      .title,
                                                  hint: "This parameter indicates the CO₂ emissions produced per megawatt-hour (MWh) of electricity generated",
                                                  "error-messages":
                                                    _vm.$utils.getIfExists(
                                                      errors,
                                                      ["co2_rate", "messages"]
                                                    ),
                                                  suffix:
                                                    _vm.thermalSchema.co2_rate
                                                      .unit,
                                                  type: "number",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.co2_rate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "co2_rate",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "item.co2_rate",
                                                },
                                              })
                                            : _vm._e(),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema
                                                  .availability_rate.title,
                                              hint: _vm.thermalSchema
                                                .availability_rate.tooltip,
                                              suffix:
                                                _vm.thermalSchema
                                                  .availability_rate.unit,
                                              type: "number",
                                              min: _vm.thermalSchema
                                                .availability_rate.minimum,
                                              max: _vm.thermalSchema
                                                .availability_rate.maximum,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.availability_rate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "availability_rate",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "item.availability_rate",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    item.type == "RENEWABLE"
                                      ? [
                                          _c("InputYearlyProfile", {
                                            attrs: {
                                              title:
                                                _vm.renewableSchema.profile
                                                  .title,
                                              suffix:
                                                _vm.renewableSchema.profile
                                                  .unit,
                                              hint: "This parameter defines the hourly generation profile expressed in per unit (p.u.) values",
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "profile",
                                                ]),
                                              num_years: _vm.num_years,
                                              "year-start": _vm.startYear,
                                              "profile-type": item.source,
                                              fill: [
                                                "HYDRO_ROR",
                                                "SOLAR_PV",
                                                "WIND",
                                              ].includes(item.source),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.profile,
                                              callback: function ($$v) {
                                                _vm.$set(item, "profile", $$v)
                                              },
                                              expression: "item.profile",
                                            },
                                          }),
                                          _c("InputToggleParam", {
                                            attrs: {
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "joint_ramping",
                                                ]),
                                              label:
                                                "Renewable + Storage Ramping Constraint",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var param = ref.param
                                                    var errors = ref.errors
                                                    return [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "error-messages":
                                                            _vm.$utils.getIfExists(
                                                              errors,
                                                              [
                                                                "ramp_rate",
                                                                "messages",
                                                              ]
                                                            ),
                                                          label: "Ramp Rate",
                                                          suffix: "%/h",
                                                          type: "number",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            param.ramp_rate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              param,
                                                              "ramp_rate",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "param.ramp_rate",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "below",
                                                  fn: function (ref) {
                                                    var param = ref.param
                                                    var disabled = ref.disabled
                                                    var errors = ref.errors
                                                    return [
                                                      _c("v-autocomplete", {
                                                        attrs: {
                                                          "error-messages":
                                                            _vm.$utils.getIfExists(
                                                              errors,
                                                              [
                                                                "storages",
                                                                "messages",
                                                              ]
                                                            ),
                                                          label:
                                                            "Energy Storage Units",
                                                          items:
                                                            _vm.input.storage,
                                                          disabled: disabled,
                                                          chips: "",
                                                          multiple: "",
                                                          "deletable-chips": "",
                                                          "item-text": "name",
                                                          "item-value": "id",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "change"
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: param.storages,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              param,
                                                              "storages",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "param.storages",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: item.joint_ramping,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "joint_ramping",
                                                  $$v
                                                )
                                              },
                                              expression: "item.joint_ramping",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  2
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Expansion")]
                                    ),
                                    _c("v-switch", {
                                      attrs: {
                                        label: "Expansion Candidate",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "expansion_candidate",
                                          ]),
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.expansion_candidate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "expansion_candidate",
                                            $$v
                                          )
                                        },
                                        expression: "item.expansion_candidate",
                                      },
                                    }),
                                    item.type === "THERMAL"
                                      ? _c("v-switch", {
                                          attrs: {
                                            label: "Count as Renewable",
                                            hint: "For minimum renewable participation (see Policies)",
                                            "persistent-hint": "",
                                            dense: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.count_as_renewable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "count_as_renewable",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.count_as_renewable",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.hydroSchema.investment.title,
                                        hint: "This parameter indicates the investment cost for constructing the unit and applies exclusively to the AA module",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "investment",
                                          ]),
                                        suffix: "$/KW",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        type: "number",
                                        fill: "",
                                        "fill-value":
                                          item.type == "THERMAL"
                                            ? 8000
                                            : _vm.hydroSchema.investment.items
                                                .default,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.investment,
                                        callback: function ($$v) {
                                          _vm.$set(item, "investment", $$v)
                                        },
                                        expression: "item.investment",
                                      },
                                    }),
                                    _c("InputYearly", {
                                      attrs: {
                                        label:
                                          _vm.hydroSchema.maximum_build.title,
                                        hint: "This parameter defines the maximum build quantity for the unit and applies exclusively to the AA module",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "maximum_build",
                                          ]),
                                        suffix: "MW",
                                        type: "number",
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        fill: "",
                                        "fill-value":
                                          _vm.hydroSchema.maximum_build.items
                                            .default,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.maximum_build,
                                        callback: function ($$v) {
                                          _vm.$set(item, "maximum_build", $$v)
                                        },
                                        expression: "item.maximum_build",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Metrics")]
                                    ),
                                    _c("v-switch", {
                                      attrs: {
                                        label:
                                          _vm.hydroSchema.LCOE_calculation
                                            .title,
                                        hint: _vm.hydroSchema.LCOE_calculation
                                          .tooltip,
                                        "persistent-hint": "",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "LCOE_Calculation",
                                          ]),
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.LCOE_Calculation,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "LCOE_Calculation",
                                            $$v
                                          )
                                        },
                                        expression: "item.LCOE_Calculation",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Financial")]
                                    ),
                                    _c("InputTextField", {
                                      class: "my-" + _vm.inputMargin,
                                      attrs: {
                                        label:
                                          _vm.hydroSchema.economic_life.title,
                                        hint: _vm.hydroSchema.economic_life
                                          .tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "economic_life",
                                            "messages",
                                          ]),
                                        suffix: "years",
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.economic_life,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "economic_life",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.economic_life",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      class: "my-" + _vm.inputMargin,
                                      attrs: {
                                        label: _vm.hydroSchema.discount.title,
                                        suffix: _vm.hydroSchema.discount.unit,
                                        hint: _vm.hydroSchema.discount.tooltip,
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "discount",
                                            "messages",
                                          ]),
                                        placeholder:
                                          _vm.input.discount &&
                                          _vm.input.discount != null
                                            ? _vm.input.discount.toString()
                                            : "",
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.discount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "discount",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.discount",
                                      },
                                    }),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Costs")]
                                    ),
                                    _c("InputYearly", {
                                      attrs: {
                                        label: _vm.hydroSchema.vom.title,
                                        hint: "This parameter defines the variable costs excluding fuel cost for the unit",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "vom",
                                          ]),
                                        num_years: _vm.num_years,
                                        year_start: _vm.startYear,
                                        suffix: "$/MWh",
                                        type: "number",
                                        fill: "",
                                        "fill-value":
                                          _vm.hydroSchema.vom.items.default,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.vom,
                                        callback: function ($$v) {
                                          _vm.$set(item, "vom", $$v)
                                        },
                                        expression: "item.vom",
                                      },
                                    }),
                                    _c("InputTextField", {
                                      attrs: {
                                        label: _vm.hydroSchema.fom.title,
                                        hint: "This parameter specifies the fixed cost for the unit and applies exclusively to the AA module",
                                        "error-messages":
                                          _vm.$utils.getIfExists(errors, [
                                            "fom",
                                            "messages",
                                          ]),
                                        suffix: "$/KW-years",
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.fom,
                                        callback: function ($$v) {
                                          _vm.$set(item, "fom", _vm._n($$v))
                                        },
                                        expression: "item.fom",
                                      },
                                    }),
                                    item.type === "RENEWABLE"
                                      ? _c("InputYearly", {
                                          attrs: {
                                            label:
                                              _vm.renewableSchema
                                                .curtailment_penalty_price
                                                .title,
                                            hint: "Cost assigned to unused available energy.",
                                            suffix:
                                              _vm.renewableSchema
                                                .curtailment_penalty_price.unit,
                                            type: "number",
                                            num_years: _vm.num_years,
                                            year_start: _vm.startYear,
                                            fill: "",
                                            "fill-value":
                                              _vm.renewableSchema
                                                .curtailment_penalty_price.items
                                                .default,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value:
                                              item.curtailment_penalty_price,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "curtailment_penalty_price",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.curtailment_penalty_price",
                                          },
                                        })
                                      : _vm._e(),
                                    item.type == "THERMAL" &&
                                    item.source !== "GEOTHERMAL"
                                      ? [
                                          _c("v-switch", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema
                                                  .profile_fuel_price.title,
                                              hint: "This parameter defines the fuel price for the unit and may be specified as either an annual constant or an hourly price profile",
                                              "persistent-hint": "",
                                              dense: "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.profile_fuel_price,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "profile_fuel_price",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.profile_fuel_price",
                                            },
                                          }),
                                          item.profile_fuel_price
                                            ? _c("InputYearlyProfile", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema
                                                      .fuel_price_profiles
                                                      .title,
                                                  hint: _vm.thermalSchema
                                                    .fuel_price_profiles
                                                    .tooltip,
                                                  num_years: _vm.num_years,
                                                  "profile-type":
                                                    _vm.thermalSchema
                                                      .fuel_price_profiles
                                                      .profileType,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    item.fuel_price_profiles,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "fuel_price_profiles",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.fuel_price_profiles",
                                                },
                                              })
                                            : _c("InputYearly", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema.fuel_price
                                                      .title,
                                                  hint: _vm.thermalSchema
                                                    .fuel_price.tooltip,
                                                  "error-messages":
                                                    _vm.$utils.getIfExists(
                                                      errors,
                                                      ["fuel_price"]
                                                    ),
                                                  suffix:
                                                    _vm.thermalSchema.fuel_unit
                                                      .default,
                                                  num_years: _vm.num_years,
                                                  year_start: _vm.startYear,
                                                  type: "number",
                                                  fill: "",
                                                  "fill-value":
                                                    _vm.thermalSchema.fuel_price
                                                      .items.default,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var year = ref.year
                                                        var value = ref.value
                                                        var type = ref.type
                                                        var readonly =
                                                          ref.readonly
                                                        var errorMessages =
                                                          ref.errorMessages
                                                        return [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              "error-messages":
                                                                errorMessages,
                                                              label:
                                                                "Year " + year,
                                                              type: type,
                                                              suffix:
                                                                _vm
                                                                  .thermalSchema
                                                                  .fuel_price
                                                                  .unit,
                                                              readonly:
                                                                readonly,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$emit(
                                                                  "change"
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                value[year - 1],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    value,
                                                                    year - 1,
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                              expression:
                                                                "value[year - 1]",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: item.fuel_price,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "fuel_price",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.fuel_price",
                                                },
                                              }),
                                        ]
                                      : _vm._e(),
                                    _c("v-switch", {
                                      attrs: {
                                        label: _vm.thermalSchema.ppa.title,
                                        hint: _vm.thermalSchema.ppa.tooltip,
                                        "persistent-hint": "",
                                        dense: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.ppa.active,
                                        callback: function ($$v) {
                                          _vm.$set(item.ppa, "active", $$v)
                                        },
                                        expression: "item.ppa.active",
                                      },
                                    }),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label:
                                              _vm.thermalSchema.ppa.properties
                                                .energy.title,
                                            hint: _vm.thermalSchema.ppa
                                              .properties.energy.tooltip,
                                            suffix: "$/MWh",
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.thermalSchema.ppa.properties
                                                .energy.profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.energy,
                                            callback: function ($$v) {
                                              _vm.$set(item.ppa, "energy", $$v)
                                            },
                                            expression: "item.ppa.energy",
                                          },
                                        })
                                      : _vm._e(),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label:
                                              _vm.thermalSchema.ppa.properties
                                                .deemedEnergy.title,
                                            hint: _vm.thermalSchema.ppa
                                              .properties.deemedEnergy.tooltip,
                                            suffix: "$/MWh",
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.thermalSchema.ppa.properties
                                                .deemedEnergy.profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.deemedEnergy,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.ppa,
                                                "deemedEnergy",
                                                $$v
                                              )
                                            },
                                            expression: "item.ppa.deemedEnergy",
                                          },
                                        })
                                      : _vm._e(),
                                    item.ppa.active
                                      ? _c("InputYearlyProfile", {
                                          attrs: {
                                            "object-value": "",
                                            fill: "",
                                            "toggle-items-type": "",
                                            label:
                                              _vm.thermalSchema.ppa.properties
                                                .capacity.title,
                                            hint: _vm.thermalSchema.ppa
                                              .properties.capacity.tooltip,
                                            suffix: "$/MW-month",
                                            num_years: _vm.num_years,
                                            "profile-type":
                                              _vm.thermalSchema.ppa.properties
                                                .capacity.profileType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.ppa.capacity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.ppa,
                                                "capacity",
                                                $$v
                                              )
                                            },
                                            expression: "item.ppa.capacity",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  2
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Capacity")]
                                    ),
                                    item.type == "THERMAL"
                                      ? [
                                          _c("InputYearly", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.capacity
                                                  .title,
                                              hint: "This parameter defines the minimum installed generator capacity for the AA module. Any increase must align with the maximum build limit. For the NPC module, this input considers only capacity.",
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "capacity",
                                                ]),
                                              suffix: "MW",
                                              num_years: _vm.num_years,
                                              year_start: _vm.startYear,
                                              type: "number",
                                              "available-years":
                                                _vm.maxCapacityYears(item),
                                              fill: "",
                                              "fill-value":
                                                _vm.thermalSchema.capacity.items
                                                  .default,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.capacity,
                                              callback: function ($$v) {
                                                _vm.$set(item, "capacity", $$v)
                                              },
                                              expression: "item.capacity",
                                            },
                                          }),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.derate_summer
                                                  .title,
                                              hint: _vm.thermalSchema
                                                .derate_summer.tooltip,
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "derate_summer",
                                                  "messages",
                                                ]),
                                              suffix: "%",
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.derate_summer,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "derate_summer",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.derate_summer",
                                            },
                                          }),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.derate_winter
                                                  .title,
                                              hint: _vm.thermalSchema
                                                .derate_winter.tooltip,
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "derate_winter",
                                                  "messages",
                                                ]),
                                              suffix: "%",
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.derate_winter,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "derate_winter",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.derate_winter",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    item.type == "RENEWABLE"
                                      ? [
                                          _c("InputYearly", {
                                            attrs: {
                                              label:
                                                "Minimum Installed Capacity",
                                              hint: "This parameter defines the minimum installed generator capacity for the AA module. Any increase must align with the maximum build limit. For the NPC module, this input considers only capacity.",
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "capacity",
                                                ]),
                                              suffix: "MW",
                                              num_years: _vm.num_years,
                                              year_start: _vm.startYear,
                                              "available-years":
                                                _vm.maxCapacityYears(item),
                                              type: "number",
                                              fill: "",
                                              "fill-value":
                                                _vm.renewableSchema.capacity
                                                  .items.default,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.capacity,
                                              callback: function ($$v) {
                                                _vm.$set(item, "capacity", $$v)
                                              },
                                              expression: "item.capacity",
                                            },
                                          }),
                                          _c("InputTextField", {
                                            attrs: {
                                              label: "Firm Power",
                                              hint: _vm.renewableSchema.firm
                                                .tooltip,
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "firm",
                                                  "messages",
                                                ]),
                                              suffix: "%",
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.firm,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "firm",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.firm",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    item.type == "HYDRO"
                                      ? [
                                          _c("InputYearly", {
                                            attrs: {
                                              label:
                                                _vm.hydroSchema.capacity.title,
                                              hint: "This parameter defines the minimum installed generator capacity for the AA module. Any increase must align with the maximum build limit. For the NPC module, this input considers only capacity.",
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "capacity",
                                                ]),
                                              suffix: "MW",
                                              num_years: _vm.num_years,
                                              year_start: _vm.startYear,
                                              "available-years":
                                                _vm.maxCapacityYears(item),
                                              type: "number",
                                              fill: "",
                                              "fill-value":
                                                _vm.hydroSchema.capacity.items
                                                  .default,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.capacity,
                                              callback: function ($$v) {
                                                _vm.$set(item, "capacity", $$v)
                                              },
                                              expression: "item.capacity",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            class: "my-" + _vm.inputMargin,
                                            attrs: {
                                              label: _vm.hydroSchema.firm.title,
                                              hint: _vm.hydroSchema.firm
                                                .tooltip,
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "firm",
                                                  "messages",
                                                ]),
                                              suffix: "%",
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.firm,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "firm",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.firm",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            class: "my-" + _vm.inputMargin,
                                            attrs: {
                                              label:
                                                _vm.hydroSchema.ramp_rate.title,
                                              hint: _vm.hydroSchema.ramp_rate
                                                .tooltip,
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "ramp_rate",
                                                  "messages",
                                                ]),
                                              suffix: "MW/h",
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.ramp_rate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "ramp_rate",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.ramp_rate",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  2
                                ),
                                ["THERMAL", "HYDRO"].includes(item.type)
                                  ? _c(
                                      "v-card",
                                      {
                                        staticClass: "mb-6",
                                        attrs: { flat: "" },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-subtitle-1 font-weight-bold",
                                          },
                                          [_vm._v("Reserves")]
                                        ),
                                        _c("InputReserve", {
                                          attrs: {
                                            label:
                                              _vm.hydroSchema.reserves.title,
                                            hint: _vm.hydroSchema.reserves
                                              .tooltip,
                                            reserves: _vm.input.reserves,
                                            "error-messages":
                                              _vm.$utils.getIfExists(errors, [
                                                "reserves",
                                              ]),
                                            suffix: "%",
                                            type: "number",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit("change")
                                            },
                                          },
                                          model: {
                                            value: item.reserves,
                                            callback: function ($$v) {
                                              _vm.$set(item, "reserves", $$v)
                                            },
                                            expression: "item.reserves",
                                          },
                                        }),
                                        _c("v-divider", {
                                          staticClass: "mt-4",
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                item.type == "HYDRO"
                                  ? [
                                      _c(
                                        "v-expansion-panels",
                                        { attrs: { multiple: "" } },
                                        [
                                          _c(
                                            "v-expansion-panel",
                                            { staticClass: "elevation-1" },
                                            [
                                              _c("v-expansion-panel-header", [
                                                _c(
                                                  "div",
                                                  { staticClass: "text-h6" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.hydroSchema
                                                            .monthly_energy
                                                            .title
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.hydroSchema
                                                            .monthly_energy
                                                            .tooltip
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c(
                                                "v-expansion-panel-content",
                                                { staticClass: "px-3" },
                                                _vm._l(
                                                  _vm.months,
                                                  function (month) {
                                                    return _c("InputYearly", {
                                                      key: month,
                                                      attrs: {
                                                        "error-messages":
                                                          _vm.$utils.getIfExists(
                                                            errors,
                                                            [
                                                              "monthly_energy",
                                                              month,
                                                            ]
                                                          ),
                                                        num_years:
                                                          _vm.num_years,
                                                        label:
                                                          month.toUpperCase(),
                                                        suffix: "GWh",
                                                        type: "number",
                                                        fill: "",
                                                        "fill-value":
                                                          _vm.hydroSchema
                                                            .monthly_energy
                                                            .properties[month]
                                                            .items.default,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "change"
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          item.monthly_energy[
                                                            month
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item.monthly_energy,
                                                            month,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.monthly_energy[month]",
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Power Flow Parameters")]
                                    ),
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.powerFlowGenTypes(item),
                                          label:
                                            "Type of the generator for power flow calculations",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.power_flow_generator_type,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "power_flow_generator_type",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item.power_flow_generator_type",
                                        },
                                      }),
                                    ],
                                    _vm.settings.POWER_FLOW.source ===
                                      "Case Inputs" &&
                                    ["sync", "static"].includes(
                                      item.power_flow_generator_type
                                    )
                                      ? [
                                          _c("v-switch", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.power_profile
                                                  .title,
                                              hint: _vm.thermalSchema
                                                .power_profile.tooltip,
                                              "persistent-hint": "",
                                              dense: "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.power_profile,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "power_profile",
                                                  $$v
                                                )
                                              },
                                              expression: "item.power_profile",
                                            },
                                          }),
                                          item.power_profile
                                            ? _c("InputYearlyProfile", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema
                                                      .active_power_profile
                                                      .title,
                                                  suffix:
                                                    _vm.thermalSchema
                                                      .active_power_profile
                                                      .unit,
                                                  hint: _vm.thermalSchema
                                                    .active_power_profile
                                                    .tooltip,
                                                  num_years: _vm.num_years,
                                                  fill: "",
                                                  "fill-value":
                                                    _vm.thermalSchema
                                                      .active_power_profile
                                                      .items.default.value,
                                                  "object-value": "",
                                                  "items-type": "profile",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.active_power,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "active_power",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.active_power",
                                                },
                                              })
                                            : _c("InputYearlyProfile", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema
                                                      .active_power.title,
                                                  suffix:
                                                    _vm.thermalSchema
                                                      .active_power.unit,
                                                  hint: _vm.thermalSchema
                                                    .active_power.tooltip,
                                                  num_years: _vm.num_years,
                                                  fill: "",
                                                  "fill-value":
                                                    _vm.thermalSchema
                                                      .active_power.items
                                                      .default.value,
                                                  "object-value": "",
                                                  "items-type": "constant",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.active_power,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "active_power",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.active_power",
                                                },
                                              }),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.scaling_factor
                                                  .title,
                                              suffix:
                                                _vm.thermalSchema.scaling_factor
                                                  .unit,
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.scaling_factor,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "scaling_factor",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.scaling_factor",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    item.power_flow_generator_type === "static"
                                      ? [
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.renewableSchema
                                                  .reactive_power.title,
                                              suffix:
                                                _vm.renewableSchema
                                                  .reactive_power.unit,
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.reactive_power,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "reactive_power",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.reactive_power",
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    item.power_flow_generator_type === "sync"
                                      ? [
                                          _c("v-switch", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema
                                                  .voltage_profile.title,
                                              hint: _vm.thermalSchema
                                                .voltage_profile.tooltip,
                                              "persistent-hint": "",
                                              dense: "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.voltage_profile,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "voltage_profile",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.voltage_profile",
                                            },
                                          }),
                                          item.voltage_profile
                                            ? _c("InputYearlyProfile", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema
                                                      .voltage_set_point_profile
                                                      .title,
                                                  suffix:
                                                    _vm.thermalSchema
                                                      .voltage_set_point_profile
                                                      .unit,
                                                  hint: _vm.thermalSchema
                                                    .voltage_set_point_profile
                                                    .tooltip,
                                                  num_years: _vm.num_years,
                                                  fill: "",
                                                  "fill-value":
                                                    _vm.thermalSchema
                                                      .voltage_set_point_profile
                                                      .items.default.value,
                                                  "object-value": "",
                                                  "items-type": "profile",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.voltage_set_point,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "voltage_set_point",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.voltage_set_point",
                                                },
                                              })
                                            : _c("InputYearlyProfile", {
                                                attrs: {
                                                  label:
                                                    _vm.thermalSchema
                                                      .voltage_set_point.title,
                                                  suffix:
                                                    _vm.thermalSchema
                                                      .voltage_set_point.unit,
                                                  hint: _vm.thermalSchema
                                                    .voltage_set_point.tooltip,
                                                  num_years: _vm.num_years,
                                                  fill: "",
                                                  "fill-value":
                                                    _vm.thermalSchema
                                                      .voltage_set_point.items
                                                      .default.value,
                                                  "object-value": "",
                                                  "items-type": "constant",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: item.voltage_set_point,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "voltage_set_point",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.voltage_set_point",
                                                },
                                              }),
                                        ]
                                      : _vm._e(),
                                    _c("InputTextField", {
                                      attrs: {
                                        label:
                                          _vm.thermalSchema.nominal_power.title,
                                        suffix:
                                          _vm.thermalSchema.nominal_power.unit,
                                        type: "number",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$emit("change")
                                        },
                                      },
                                      model: {
                                        value: item.nominal_power,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "nominal_power",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "item.nominal_power",
                                      },
                                    }),
                                    item.power_flow_generator_type !== "slack"
                                      ? _c("v-switch", {
                                          attrs: {
                                            label: "Run contingency",
                                            hint: "Consider this generator in an n-1 contingency analysis. Can't be done for slack generators.",
                                            "persistent-hint": "",
                                          },
                                          model: {
                                            value: item.run_contingency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "run_contingency",
                                                $$v
                                              )
                                            },
                                            expression: "item.run_contingency",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  2
                                ),
                                _c(
                                  "v-card",
                                  { staticClass: "mb-6", attrs: { flat: "" } },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-subtitle-1 font-weight-bold",
                                      },
                                      [_vm._v("Short Circuit Parameters")]
                                    ),
                                    _vm.defaultStatic(item.source)
                                      ? [
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.renewableSchema
                                                  .nominal_current_to_SC_ratio
                                                  .title,
                                              suffix:
                                                _vm.renewableSchema
                                                  .nominal_current_to_SC_ratio
                                                  .unit,
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                item.nominal_current_to_SC_ratio,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "nominal_current_to_SC_ratio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.nominal_current_to_SC_ratio",
                                            },
                                          }),
                                        ]
                                      : [
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.rated_voltage
                                                  .title,
                                              suffix:
                                                _vm.thermalSchema.rated_voltage
                                                  .unit,
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.rated_voltage,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "rated_voltage",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.rated_voltage",
                                            },
                                          }),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema
                                                  .subtransient_reactance.title,
                                              suffix:
                                                _vm.thermalSchema
                                                  .subtransient_reactance.unit,
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                item.subtransient_reactance,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "subtransient_reactance",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "item.subtransient_reactance",
                                            },
                                          }),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema
                                                  .subtransient_resistance
                                                  .title,
                                              suffix:
                                                _vm.thermalSchema
                                                  .subtransient_resistance.unit,
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                item.subtransient_resistance,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "subtransient_resistance",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "item.subtransient_resistance",
                                            },
                                          }),
                                          _c("InputTextField", {
                                            attrs: {
                                              label:
                                                _vm.thermalSchema.cos_phi.title,
                                              suffix:
                                                _vm.thermalSchema.cos_phi.unit,
                                              type: "number",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.cos_phi,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "cos_phi",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "item.cos_phi",
                                            },
                                          }),
                                        ],
                                    _c("v-divider", { staticClass: "mt-4" }),
                                  ],
                                  2
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.computedInput.generators,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedInput, "generators", $$v)
                  },
                  expression: "computedInput.generators",
                },
              },
              "Aggregate",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _c(
            "v-expansion-panels",
            { staticClass: "mb-3", attrs: { popout: "" } },
            [
              _c(
                "v-expansion-panel",
                {
                  staticClass: "elevation-1",
                  on: {
                    input: function ($event) {
                      _vm.chartVisible = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "text-h6" }, [
                            _vm._v("Generator Capacity by Fuel Type"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "ChartYearly",
                    _vm._b(
                      {
                        attrs: { visible: _vm.chartVisible, type: "doughnut" },
                      },
                      "ChartYearly",
                      _vm.generatorChart,
                      false
                    )
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _c(
            "CardSimple",
            { attrs: { title: "Capacity of All Units" } },
            [
              _c("ChartStacked", {
                attrs: {
                  items: _vm.input.generators.concat(_vm.input.storage),
                  valueKey: "capacity",
                  num_years: _vm.num_years,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }